import { forwardRef, Button, type ButtonProps } from '@chakra-ui/react';

export const GhostButton = forwardRef<ButtonProps, 'button'>((props, ref) => (
  <Button ref={ref} variant='text' {...props} />
));
